
define('modules/application/wizard/classes/telephony',[
    "app",

    "backbone",

    //Classes
    "./genericEnabler"

  ],

  function(app, Backbone, genericEnabler) {

    var telephony = _.extend({}, telephony, {

      Views: {
        titleBar: genericEnabler.Views.titleBar.extend({
          setLabel: function() {
            var value = this.model.get("value") ? $.i18n._("IDS_W1_9047") : $.i18n._("IDS_W1_9048");

            if (this.model.get("value"))
              value += " - " + this.model.get("accessories").vctQuantity + " " + $.i18n._("IDS_WAV1_618");

            if ((this.model.get("enabled")) && (value)) {
              this.$el.find(".caption").html(value);
              this.$el.find(".caption").fadeIn(200);
            } else
              this.$el.find(".caption").fadeOut(200, function() {
                $(this).hide();
              });
          }
        }),
        content: genericEnabler.Views.content.extend({
          events: {
            "click  .enablingSection .radio": "updateValue",
            "click  .urbanLineExpansion .radio": "updateUrbanLineExpansionValue",
            "click  .expansion1 .radio": "updateExpansion1",
            "click  .expansion2 .radio": "updateExpansion2",
            "click  .urbanLineProtection .ui-spinner-down": "decrementUrbanLineProtectionClickedEventHandler",
            "click  .urbanLineProtection .ui-spinner-up": "incrementUrbanLineProtectionClickedEventHandler",
            "click  .vct .ui-spinner-down": "decrementVctClickedEventHandler",
            "click  .vct .ui-spinner-up": "incrementVctClickedEventHandler",
            "change .powerSupply select": "powerSupplyChangedEventHandler",
            "change .vctSelector": "vctChangedEventHandler",
            "change .vctAccessorySelector": "vctAccessoryChangedEventHandler",
            "click .toggleInfoButton": "toggleInfos",
            "click .toggleVctInfoButton": "toggleVctInfos"
          },
          template: "application/wizard/sections/genericEnabler/telephony",

          toggleInfos: function(e) {
            return genericEnabler.Views.content.prototype.toggleInfos(e, this);
          },

          toggleVctInfos: function(e) {
            var that = this;
            e.preventDefault();

            if (window.isBrowserCompatibleWithAnimation()) {
              if (this.$el.find(".vctTooltip:visible").length > 0)
                that.$el.find(".arrow-info").transition({
                  rotate: '180deg'
                });
              else
                that.$el.find(".arrow-info").transition({
                  rotate: '0deg'
                });
            } else {
              if (this.$el.find(".vctTooltip:visible").length > 0)
                that.$el.find(".arrow-info").attr("src", "/assets/img/info-arrow-down.png");
              else
                that.$el.find(".arrow-info").attr("src", "/assets/img/info-arrow-up.png");
            }

            if (this.$el.find(".vctTooltip:visible").length === 0)
              that.$el.find("hr").toggle();

            this.$el.find(".vctTooltip").slideToggle(function() {
              if (that.$el.find(".vctTooltip:visible").length === 0) that.$el.find("hr").toggle();
            });
            return false;
          },

          updateUrbanLineExpansionValue: function(e) {
            var enabled = (this.$el.find(".urbanLineExpansion input:checked").val() === "true");
            var accessories = $.extend(true, {}, this.model.get("accessories"));
            var urbanLineExpansion = $.extend(true, {}, accessories.urbanLineExpansion);
            urbanLineExpansion.value = enabled;
            accessories.urbanLineExpansion = urbanLineExpansion;
            this.model.set("accessories", accessories);
          },

          updateExpansion1: function(e) {
            var enabled = (this.$el.find(".expansion1 input:checked").val() === "true");

            if (this.model.isPossibleToUpdateExpansion1(enabled)) {
              var accessories = $.extend(true, {}, this.model.get("accessories"));
              var expansion1 = $.extend(true, {}, accessories.expansion1);
              expansion1.value = enabled;
              accessories.expansion1 = expansion1;
              this.model.set("accessories", accessories);
              if (!enabled) {
                this.model.disableExpansion2();
              }
              this.afterRender();
            } else {
              alert("You cannot proceed");
              this.render();
            }
          },

          updateExpansion2: function(e) {
            var enabled = (this.$el.find(".expansion2 input:checked").val() === "true");
            if (this.model.isPossibleToUpdateExpansion2(enabled)) {
              var accessories = $.extend(true, {}, this.model.get("accessories"));
              var expansion2 = $.extend(true, {}, accessories.expansion2);
              expansion2.value = enabled;
              accessories.expansion2 = expansion2;
              this.model.set("accessories", accessories);
            } else {
              alert("You cannot proceed");
              this.render();
            }
          },

          decrementUrbanLineProtectionClickedEventHandler: function(e) {
            this.model.decrementUrbanLineProtection();
          },

          incrementUrbanLineProtectionClickedEventHandler: function(e) {
            this.model.incrementUrbanLineProtection();
          },

          decrementVctClickedEventHandler: function(e) {
            this.model.decrementVct();
          },

          incrementVctClickedEventHandler: function(e) {
            this.model.incrementVct();
          },

          powerSupplyChangedEventHandler: function(e) {
            var selectedPackageClass = e.target.value;
            this.model.setPowerSupply(e.target.value);
          },

          vctChangedEventHandler: function(e) {
            var selectedPackageClass = e.target.value;
            this.model.setVct(e.target.value);
          },

          vctAccessoryChangedEventHandler: function(e) {
            var selectedPackageClass = e.target.value;
            this.model.setVctAccessory(e.target.value);
          },

          beforeRender: function() {
            var enabled = this.model.get("value");

            if (!enabled)
              this.model.resetValues();
          },

          afterRender: function() {
            var enabled = this.model.get("value");
            var expansion1Enabled = false;

            if (!enabled) {
              this.$el.find(".accessories input").attr("disabled", "disabled");
              this.$el.find(".vct input").attr("disabled", "disabled");
              this.$el.find(".vct select").attr("disabled", "disabled");
              this.$el.find(".vct .spinner-container").addClass("disabled");
            } else {
              this.$el.find(".accessories input:not([name='expansion2'])").removeAttr("disabled");
              this.$el.find(".accessories .spinner-container").removeClass("disabled");

              expansion1Enabled = this.$el.find(".accessories input[name='expansion1']:checked").val() === "true";
              if (expansion1Enabled) {
                this.$el.find(".accessories input:[name='expansion2']").removeAttr("disabled");
                this.$el.find(".accessories .powerSupply select").removeAttr("disabled");
              } else {
                this.$el.find(".accessories input:[name='expansion2']").attr("disabled", "disabled");
                this.$el.find(".accessories .powerSupply select").attr("disabled", "disabled");
              }
            }
            this.$el.find(".radio").remove();
            this.$el.find("input").removeAttr("rel");
            this.$el.find("select").removeAttr("rel");

            genericEnabler.Views.content.prototype.afterRender.apply(this);
          }

        })
      },

      Model: genericEnabler.Model.extend({
        defaults: _.extend({
          name: "IDS_WAV8_9",
          quote: "IDS_WAV1_612",
          infoQuote: "IDS_WGENTT_000030",
          vctInfoQuote: "IDS_WGENTT_000031",
          value: false,
          bonusUrbanLines: 2,
          bonusDerivates: 8,
          maxUrbanLines: 0,
          maxDerivates: 0,
          accessories: {
            urbanLineExpansion: {
              idWizardChoice: 613,
              value: false,
              deliverCurrent: function() {}
            },
            urbanLineProtection: {
              idWizardChoice: 614,
              value: 0,
              deliverCurrent: function() {}
            },
            expansion1: {
              idWizardChoice: 615,
              value: false,
              deliverCurrent: function() {}
            },
            expansion2: {
              idWizardChoice: 616,
              value: false,
              deliverCurrent: function() {}
            },
            powerSupply: {
              idWizardChoice: 617,
              deliverCurrent: function() {}
            },
            vctQuantity: 0,
            vct: {
              idWizardChoice: 618,
              deliverCurrent: function(vctQuantity) {

                var objectToAnalyse,
                  maxNonPoweredVct = BticinoS4B.Instances.Models.ApplicationModel.get("maxNonPoweredVct");

                //Helper method for consumption send
                var sendConsumption = function(consumption) {
                  if (consumption) {
                    var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

                    if (consumption < 0) {
                      consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
                      consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
                    } else {
                      consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
                      consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
                    }
                  }
                };

                for (var i = 0; i < vctQuantity; i++) {
                  if (i < maxNonPoweredVct)
                    objectToAnalyse = this.value[0];
                  else
                    objectToAnalyse = this.value[1];

                  if (objectToAnalyse.specialVars) {
                    var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

                    if (!(objectToAnalyse.specialVars) instanceof Object)
                      objectToAnalyse.specialVars = JSON.parse(objectToAnalyse.specialVars);

                    var currentConsumption = objectToAnalyse.specialVars.currentConsumption;
                    if ((objectToAnalyse.specialVars.consumptionGroupId) && (objectToAnalyse.specialVars.groupExtraConsumption)) {
                      var consumptionGroupId = objectToAnalyse.specialVars.consumptionGroupId.toString();
                      var groupExtraConsumption = objectToAnalyse.specialVars.groupExtraConsumption;
                      var conversationMaxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("conversationMaxExtraConsumption");
                      var soundDiffusionMaxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("soundDiffusionMaxExtraConsumption");

                      if ((!conversationMaxExtraConsumptions[consumptionGroupId]) || (conversationMaxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                        conversationMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

                      if ((!soundDiffusionMaxExtraConsumptions[consumptionGroupId]) || (soundDiffusionMaxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                        soundDiffusionMaxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

                      BticinoS4B.Instances.Models.ApplicationModel.set("conversationMaxExtraConsumption", conversationMaxExtraConsumptions);
                      BticinoS4B.Instances.Models.ApplicationModel.set("soundDiffusionMaxExtraConsumption", soundDiffusionMaxExtraConsumptions);
                    }

                    sendConsumption(currentConsumption);
                  }
                }
              }
            },
            vctAccessory: {
              idWizardChoice: 619,
              deliverCurrent: function() {}
            }
          }
        }, genericEnabler.Model.prototype.defaults),

        initialize: function() {
          genericEnabler.Model.prototype.initialize.apply(this);
          this.initializeAccessories();

          this.bind("change:value", this.valueChangedEventHandler, this);
          this.bind("change:accessories", this.calculateBonuses, this);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);
          BticinoS4B.Instances.Models.ApplicationModel.bind("change:filterId", this.systemFilterUpdatedEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          this.fetchAccessories();
          this.systemFilterUpdatedEventHandler();
        },

        initializeAccessories: function() {
          var accessories = _.extend({}, this.get("accessories"));

          if (accessories) {
            //Merging loaded urbanLineExpansion with the default one
            if (accessories._urbanLineExpansion)
              accessories.urbanLineExpansion = _.extend(this.defaults.accessories.urbanLineExpansion, accessories._urbanLineExpansion);

            //Merging loaded urbanLineProtection with the default one
            if (accessories._urbanLineProtection)
              accessories.urbanLineProtection = _.extend(this.defaults.accessories.urbanLineProtection, accessories._urbanLineProtection);

            //Merging loaded expansion1 with the default one
            if (accessories._expansion1)
              accessories.expansion1 = _.extend(this.defaults.accessories.expansion1, accessories._expansion1);

            //Merging loaded expansion2 with the default one
            if (accessories._expansion2)
              accessories.expansion2 = _.extend(this.defaults.accessories.expansion2, accessories._expansion2);

            //Merging loaded powerSupply with the default one
            if (accessories._powerSupply)
              accessories.powerSupply = _.extend(this.defaults.accessories.powerSupply, accessories._powerSupply);

            //Merging loaded vct with the default one
            if (accessories._vct)
              accessories.vct = _.extend(this.defaults.accessories.vct, accessories._vct);

            //Merging loaded vct with the default one
            if (accessories._vctQuantity)
              accessories.vctQuantity = accessories._vctQuantity;

            //Merging loaded vctAccessory with the default one
            if (accessories._vctAccessory)
              accessories.vctAccessory = _.extend(this.defaults.accessories.vctAccessory, accessories._vctAccessory);

            this.set("accessories", accessories);
          }
        },

        setPowerSupply: function(powerSupplyPackage) {
          if (!(powerSupplyPackage instanceof Object)) {
            var completePackage = _.filter(this.get("accessories").fetchedPowerSupplies, function(currentPackage) {
              return currentPackage.packageClassId === powerSupplyPackage;
            });

            if (completePackage.length > 0)
              powerSupplyPackage = completePackage[0];
            else
              powerSupplyPackage = undefined;
          }
          var accessories = _.extend({}, this.get("accessories"));
          var powerSupply = _.extend({}, accessories.powerSupply);

          if (powerSupplyPackage) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(powerSupplyPackage.packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              if (products.length > 0) {
                _.extend(powerSupplyPackage, products[0]);
              }
            });

            powerSupply.value = powerSupplyPackage;
            accessories.powerSupply = powerSupply;
            this.set("accessories", accessories);
            this.trigger("render:requested");
          }
        },

        setVct: function(vctPackage) {
          var fetchedVcts = this.get("accessories").fetchedVcts,
            fetchedVctsLength = fetchedVcts.length,
            completePackage = {};

          if (!(vctPackage instanceof Object)) {
            completePackage = _.filter(this.get("accessories").fetchedVcts, function(currentPackages) {
              for (var i = 0; i < currentPackages.length; i++)
                if (currentPackages[i].packageClassId === vctPackage)
                  return true;
            });


            if (completePackage.length > 0) {
              vctPackage = completePackage[0];
            } else
              vctPackage = undefined;

          }
          var accessories = _.extend({}, this.get("accessories"));
          var vct = _.extend({}, accessories.vct);

          if (vctPackage) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(vctPackage[1].packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              if (products.length > 0) {
                products[0].secondaryProducts = secondaryProducts;

                for (var i = 0; i < vctPackage.length; i++)
                  _.extend(vctPackage[i], products[0]);

              }
            });

            vct.value = vctPackage;
            accessories.vct = vct;
            this.set("accessories", accessories);

            this.trigger("render:requested");
          }
        },

        setVctAccessory: function(vctAccessoryPackage) {
          var accessories = this.get("accessories");

          if (!(vctAccessoryPackage instanceof Object)) {
            var completePackage = _.filter(this.get("accessories").fetchedVctAccessories, function(currentPackage) {
              return currentPackage.packageClassId === vctAccessoryPackage;
            });

            if (completePackage.length > 0)
              vctAccessoryPackage = completePackage[0];
            else
              vctAccessoryPackage = undefined;

          }
          var vctAccessory = _.extend({}, accessories.vctAccessory);

          if (vctAccessoryPackage) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(vctAccessoryPackage.packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              if (products.length > 0) {
                _.extend(vctAccessoryPackage, products[0]);
              }
            });

            vctAccessory.value = vctAccessoryPackage;
            accessories.vctAccessory = vctAccessory;
            this.set("accessories", accessories);
            this.trigger("render:requested");
          }
        },

        fetchAccessories: function() {
          this.fetchUrbanLineExpansion();
          this.fetchUrbanLineProtection();
          this.fetchExpansion1();
          this.fetchExpansion2();
          this.fetchPowerSupplies();
          this.fetchVcts();
          this.fetchVctAccessories();
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        fetchUrbanLineExpansion: function() {
          var that = this,
            accessories = _.extend({}, this.get("accessories")),
            urbanLineExpansion = accessories.urbanLineExpansion;
          var expansion;

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(613, function(data) {
            expansion = data.packages.length > 0 ? data.packages[0] : null;
            expansion.specialVars = JSON.parse(expansion.specialVars);

            if (expansion) {
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(expansion.packageClassId, function(data) {
                data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                var products = _.filter(data.products, function(product) {
                  return (product.mnemonic === 1);
                });
                var secondaryProducts = _.filter(data.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                if (products.length > 0)
                  _.extend(expansion, products[0]);

                expansion.secondaryProducts = secondaryProducts;
              });
              _.extend(urbanLineExpansion, expansion);
              that.set("accessories", accessories);
            }
          });
        },

        fetchUrbanLineProtection: function() {
          var that = this,
            accessories = _.extend({}, this.get("accessories")),
            urbanLineProtection = accessories.urbanLineProtection;
          var protection;

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(614, function(data) {
            protection = data.packages.length > 0 ? data.packages[0] : null;
            protection.specialVars = JSON.parse(protection.specialVars);
            if (protection) {
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(protection.packageClassId, function(data) {
                data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                var products = _.filter(data.products, function(product) {
                  return (product.mnemonic === 1);
                });
                var secondaryProducts = _.filter(data.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                if (products.length > 0)
                  _.extend(protection, products[0]);

                protection.secondaryProducts = secondaryProducts;
              });
              _.extend(urbanLineProtection, protection);
              that.set("accessories", accessories);
            }
          });
        },

        fetchExpansion1: function() {
          var that = this,
            accessories = _.extend({}, this.get("accessories")),
            expansion1 = accessories.expansion1;
          var expansion;

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(615, function(data) {
            expansion = data.packages.length > 0 ? data.packages[0] : null;
            expansion.specialVars = JSON.parse(expansion.specialVars);

            if (expansion) {
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(expansion.packageClassId, function(data) {
                data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                var products = _.filter(data.products, function(product) {
                  return (product.mnemonic === 1);
                });
                var secondaryProducts = _.filter(data.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                if (products.length > 0)
                  _.extend(expansion, products[0]);

                expansion.secondaryProducts = secondaryProducts;
              });
              _.extend(expansion1, expansion);
              that.set("accessories", accessories);
            }
          });
        },

        fetchExpansion2: function() {
          var that = this,
            accessories = _.extend({}, this.get("accessories")),
            expansion2 = accessories.expansion2;
          var expansion;

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(616, function(data) {
            expansion = data.packages.length > 0 ? data.packages[0] : null;
            expansion.specialVars = JSON.parse(expansion.specialVars);

            if (expansion) {
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(expansion.packageClassId, function(data) {
                data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                var products = _.filter(data.products, function(product) {
                  return (product.mnemonic === 1);
                });
                var secondaryProducts = _.filter(data.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                if (products.length > 0)
                  _.extend(expansion, products[0]);

                expansion.secondaryProducts = secondaryProducts;
              });
              _.extend(expansion2, expansion);
              that.set("accessories", accessories);
            }
          });
        },

        fetchPowerSupplies: function() {
          var that = this;
          var accessories = _.extend({}, this.get("accessories"));
          var powerSupply = _.extend({}, accessories.powerSupply);

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(617, function(data) {
            accessories.fetchedPowerSupplies = data.packages;

            if ((!powerSupply.value) && (accessories.fetchedPowerSupplies.length > 0))
              that.setPowerSupply(accessories.fetchedPowerSupplies[0]);
            else if (powerSupply.value && powerSupply.value.packageClassId)
              that.setPowerSupply(
                _.filter(accessories.fetchedPowerSupplies, function(currentPowerSupply) {
                  return currentPowerSupply.packageClassId === powerSupply.value.packageClassId;
                })[0]
              );

            accessories = that.get("accessories");
            accessories.fetchedPowerSupplies = data.packages;
            that.set("accessories", accessories);
          });
          this.trigger("render:requested");
        },

        fetchVcts: function() {
          var that = this;
          var accessories = _.extend({}, this.get("accessories"));
          var vct = _.extend({}, accessories.vct);

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(618, function(data) {
            accessories.fetchedVcts = data.packages;
            var fetchedPackages = accessories.fetchedVcts;
            var unAggregablePackages = [];
            var i = 0;

            for (i = 0; i < fetchedPackages.length; i++)
              if (fetchedPackages[i].specialVars && (!(fetchedPackages[i].specialVars instanceof Object))) {
                if (fetchedPackages[i].specialVars !== "")
                  fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);
                else
                  fetchedPackages[i].specialVars = undefined;
              }


              //Group packages by aggregationId
            var groupedFetchedPackages = _.groupBy(fetchedPackages, function(currentPackage) {
              if (currentPackage.specialVars)
                return currentPackage.specialVars.aggregationId ? currentPackage.specialVars.aggregationId : null;
              else
                return null;
            });

            //Group packages by aggregationId
            _.each(groupedFetchedPackages, function(groupOfPackages, key) {
              if (groupOfPackages.length === 1)
                unAggregablePackages.push(groupOfPackages[0]);
              else if ((groupOfPackages.length > 1) && (key !== "null")) {
                for (i = 0; i < groupOfPackages.length; i++)
                  groupOfPackages[i].specialVars = _.extend(groupOfPackages[i].specialVars, {
                    groupable: true
                  });
              }
            });

            //Group unaggregable packages
            groupedFetchedPackages = _.filter(groupedFetchedPackages, function(group) {
              return ((group.length > 1) || (group.key === "null"));
            });

            //Mergin broken couples with unaggregables
            if (!groupedFetchedPackages["null"])
              groupedFetchedPackages["null"] = [];

            for (i = 0; i < unAggregablePackages.length; i++) {
              delete unAggregablePackages[i].specialVars.aggregationId;
              delete unAggregablePackages[i].specialVars.groupable;
              groupedFetchedPackages["null"].push(unAggregablePackages[i]);
            }

            accessories.fetchedVcts = groupedFetchedPackages;
            that.set("accessories", accessories);

            if ((!vct.value) && (accessories.fetchedVcts.length > 0))
              if (accessories.vct.packageClassId)
                that.setVct(accessories.vct.packageClassId);
              else
                that.setVct(groupedFetchedPackages[0][1].packageClassId);
              else
                this.setVct(undefined);

          });
          this.trigger("render:requested");
        },

        fetchVctAccessories: function() {
          var that = this;
          var accessories = _.extend({}, this.get("accessories"));
          var vctAccessory = _.extend({}, accessories.vctAccessory);

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(619, function(data) {
            accessories.fetchedVctAccessories = data.packages;

            for (var i = 0; i < accessories.fetchedVctAccessories.length; i++)
              if (!(accessories.fetchedVctAccessories[i].specialVars instanceof Object))
                accessories.fetchedVctAccessories[i].specialVars = JSON.parse(accessories.fetchedVctAccessories[i].specialVars);

            that.set("accessories", accessories);

            if ((!vctAccessory.value) && (accessories.fetchedVctAccessories.length > 0))
              if (vctAccessory.packageClassId)
                that.setVctAccessory(vctAccessory.packageClassId);
              else
                that.setVctAccessory(accessories.fetchedVctAccessories[0].packageClassId);
              else
                that.setVctAccessory(undefined);
          });
        },

        resetValues: function() {
          var accessories = _.extend({}, this.get("accessories"));
          var urbanLineExpansion = accessories.urbanLineExpansion;
          var urbanLineProtection = accessories.urbanLineProtection;
          var expansion1 = accessories.expansion1;
          var expansion2 = accessories.expansion2;
          var powerSupply = accessories.powerSupply;
          var vct = accessories.vct;

          urbanLineExpansion.value = false;
          urbanLineProtection.value = 0;
          expansion1.value = false;
          expansion2.value = false;

          accessories.urbanLineExpansion = urbanLineExpansion;
          accessories.urbanLineProtection = urbanLineProtection;
          accessories.expansion1 = expansion1;
          accessories.expansion2 = expansion2;

          this.set("accessories", accessories);
        },

        disableExpansion2: function() {
          var accessories = _.extend({}, this.get("accessories"));
          var expansion2 = accessories.expansion2;
          expansion2.value = false;
          accessories.expansion2 = expansion2;
          this.set("accessories", accessories);
          this.trigger("render:requested");
        },

        calculateBonuses: function() {
          var accessories = this.get("accessories");
          var maxUrbanLines = 0;
          var maxDerivates = 0;

          //Calculating urban lines bonus
          if (this.get("value")) {
            maxUrbanLines += this.get("bonusUrbanLines");
            maxDerivates += this.get("bonusDerivates");
          } else
            maxUrbanLines = 0;

          if ((accessories.urbanLineExpansion) && (accessories.urbanLineExpansion.value))
            maxUrbanLines += 2;

          if (accessories.expansion1 && accessories.expansion1.value)
            maxDerivates += 8;

          if (accessories.expansion2 && accessories.expansion2.value)
            maxDerivates += 8;

          this.set("maxUrbanLines", maxUrbanLines);
          this.set("maxDerivates", maxDerivates);
          BticinoS4B.Instances.Models.ApplicationModel.set("maxDerivates", maxDerivates);
        },

        valueChangedEventHandler: function() {
          var value = this.get("value");
          var vctsCollectionLength = this.get("accessories") ? this.get("accessories").vctQuantity : 0;

          if (!value) {
            if (vctsCollectionLength === 0) {
              this.setPowerSupply(this.get("accessories").fetchedPowerSupplies[0].packageClassId);
              this.calculateBonuses();
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              this.trigger("render:requested");
            } else {
              alert($.i18n._("IDS_W1_9106"));
              this.set("value", true);
            }
          } else {
            this.setPowerSupply(this.get("accessories").fetchedPowerSupplies[0].packageClassId);
            this.calculateBonuses();
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            this.trigger("render:requested");
          }

          this.trigger("abilitation:changed");
        },

        decrementVct: function() {
          if (this.get("value")) {
            var accessories = _.extend({}, this.get("accessories"));
            var vctQuantity = accessories.vctQuantity;

            if ((vctQuantity - 1) >= 0) {
              vctQuantity--;
              accessories.vctQuantity = vctQuantity;
              this.set("accessories", accessories);
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              this.trigger("vctQuantity:changed");
              this.trigger("render:requested");
            } else
              alert("You cannot proceed");
          }
        },

        incrementVct: function() {
          if (this.get("value")) {
            var maxDerivates = BticinoS4B.Instances.Models.ApplicationModel.get("maxDerivates") ? BticinoS4B.Instances.Models.ApplicationModel.get("maxDerivates") : 0;
            var accessories = _.extend({}, this.get("accessories"));
            var vctQuantity = accessories.vctQuantity;

            if ((vctQuantity + 1) <= maxDerivates) {
              vctQuantity++;
              accessories.vctQuantity = vctQuantity;
              this.set("accessories", accessories);
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              this.trigger("vctQuantity:changed");
              this.trigger("render:requested");
            } else
              alert("You cannot proceed");
          }
        },

        decrementUrbanLineProtection: function() {
          if (this.get("value")) {
            var accessories = _.extend({}, this.get("accessories"));
            var urbanLineProtection = accessories.urbanLineProtection;

            if ((urbanLineProtection.value - 1) >= 0) {
              urbanLineProtection.value--;
              this.set("accessories", accessories);
              this.trigger("render:requested");
            } else
              alert("You cannot proceed");
          }
        },

        incrementUrbanLineProtection: function() {
          if (this.get("value")) {
            var maxUrbanLineProtection = this.get("maxUrbanLines");
            var accessories = _.extend({}, this.get("accessories"));
            var urbanLineProtection = accessories.urbanLineProtection;

            if ((urbanLineProtection.value + 1) <= maxUrbanLineProtection) {
              urbanLineProtection.value++;
              this.set("accessories", accessories);
              this.trigger("render:requested");
            } else
              alert("You cannot proceed");
          }
        },

        retrieveProducts: function() {
          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(612, function(data) {
              var packages = data.packages;
              if (packages.length > 0) {
                _.extend(that.attributes, packages[0]);
                BticinoS4B.Instances.Models.ApplicationModel.getProducts(packages[0].packageClassId, function(data) {
                  data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                  var products = _.filter(data.products, function(product) {
                    return (product.mnemonic === 1);
                  });
                  var secondaryProducts = _.filter(data.products, function(product) {
                    return (product.mnemonic !== 1);
                  });

                  if (products.length > 0) {
                    _.extend(that.attributes, products[0]);
                  }

                  that.set("secondaryProducts", secondaryProducts);
                  window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
                });
              }
            });
          }
        },

        deliverCurrentAccessories: function() {
          var accessories = this.get("accessories");
          accessories.urbanLineExpansion.deliverCurrent();
          accessories.urbanLineProtection.deliverCurrent();
          accessories.expansion1.deliverCurrent();
          accessories.expansion2.deliverCurrent();
          accessories.powerSupply.deliverCurrent();
          accessories.vct.deliverCurrent(this.get("accessories").vctQuantity);
        },

        deliverCurrent: function() {

          //Helper method for consumption send
          var sendConsumption = function(consumption) {
            if (consumption) {
              var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

              if (consumption < 0) {
                consumptionIndicatorModel.addConversationSupplyCurrent(consumption);
                consumptionIndicatorModel.addSoundDiffusionSupplyCurrent(consumption);
              } else {
                consumptionIndicatorModel.addConversationCurrentConsumption(consumption);
                consumptionIndicatorModel.addSoundDiffusionCurrentConsumption(consumption);
              }
            }
          };

          if (this.get("specialVars")) {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

            if (!(this.get("specialVars") instanceof Object))
              this.attributes.specialVars = JSON.parse(this.attributes.specialVars);

            var currentConsumption = this.get("specialVars").currentConsumption;

            if (this.get("value")) {

              if ((this.get("specialVars").consumptionGroupId) && (this.get("specialVars").groupExtraConsumption)) {
                var consumptionGroupId = this.get("specialVars").consumptionGroupId.toString();
                var groupExtraConsumption = this.get("specialVars").groupExtraConsumption;
                var maxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

                if ((!maxExtraConsumptions[consumptionGroupId]) || (maxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                  maxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

                BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", maxExtraConsumptions);
              }

              sendConsumption(currentConsumption);
              this.deliverCurrentAccessories();
            }
          }
        },

        getMinimumAttributes: function(objectToAnalyse) {
          if (objectToAnalyse.attributes)
            return {
              packageClassDescription: objectToAnalyse.get("packageClassDescription"),
              packageClassId: objectToAnalyse.get("packageClassId"),
              packageClassLabel: objectToAnalyse.get("packageClassLabel"),
              price: objectToAnalyse.get("price"),
              productCode: objectToAnalyse.get("productCode"),
              productDescription: objectToAnalyse.get("productDescription"),
              productInDepth: objectToAnalyse.get("productInDepth"),
              productLabel: objectToAnalyse.get("productLabel"),
              wizardChoiceDescription: objectToAnalyse.get("wizardChoiceDescription"),
              wizardChoiceLabel: objectToAnalyse.get("wizardChoiceLabel")
            };
          else
            return {
              packageClassDescription: objectToAnalyse.packageClassDescription,
              packageClassId: objectToAnalyse.packageClassId,
              packageClassLabel: objectToAnalyse.packageClassLabel,
              price: objectToAnalyse.price,
              productCode: objectToAnalyse.productCode,
              productDescription: objectToAnalyse.productDescription,
              productInDepth: objectToAnalyse.productInDepth,
              productLabel: objectToAnalyse.productLabel,
              wizardChoiceDescription: objectToAnalyse.wizardChoiceDescription,
              wizardChoiceLabel: objectToAnalyse.wizardChoiceLabel
            };
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.telephony = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.telephony = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.telephony = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.telephony = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.telephony = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.telephony = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("telephony", this);
          if (this.get("value")) {
            var objectToPush;
            var internals = BticinoS4B.Instances.Models.ApplicationModel.get("internals"),
              i = 0;

            objectToPush = this.getMinimumAttributes(this);
            internals.push(objectToPush);

            //Retrieving urbanLineExpansion
            objectToPush = this.get("accessories").urbanLineExpansion;
            if (objectToPush.value) {
              objectToPush = this.getMinimumAttributes(objectToPush);
              internals.push(objectToPush);
            }

            //Retrieving urbanLineProtection
            objectToPush = this.get("accessories").urbanLineProtection;
            if (objectToPush.value > 0) {
              objectToPush = this.getMinimumAttributes(objectToPush);
              objectToPush.quantity = this.get("accessories").urbanLineProtection.value;
              internals.push(objectToPush);
            }

            //Retrieving expansion1
            objectToPush = this.get("accessories").expansion1;
            if (objectToPush.value) {
              objectToPush = this.getMinimumAttributes(objectToPush);
              internals.push(objectToPush);
            }

            //Retrieving expansion2
            objectToPush = this.get("accessories").expansion2;
            if (objectToPush.value) {
              objectToPush = this.getMinimumAttributes(objectToPush);
              internals.push(objectToPush);
            }

            //Retrieving powerSupply
            objectToPush = this.get("accessories").powerSupply;
            if (objectToPush.value) {
              objectToPush = this.getMinimumAttributes(objectToPush.value);
              internals.push(objectToPush);
            }
            switch (BticinoS4B.vars.system.id) {
              case '#2':
                BticinoS4B.solution.thermoregulation.internals = internals;
                break;
              case '#4':
                BticinoS4B.solution.intrusionDetection.internals = internals;
                break;
              case '#5+6':
                BticinoS4B.solution.audioVideo.internals = internals;
                break;
              case '#13+20':
                BticinoS4B.solution.automation.internals = internals;
                break;
            };
            BticinoS4B.Instances.Models.ApplicationModel.set("internals", internals);
          }
        },

        systemFilterUpdatedEventHandler: function() {
          var newFilterId = BticinoS4B.Instances.Models.ApplicationModel.get("filterId");

          if ((newFilterId === 1) || (newFilterId === 2) || (newFilterId === 4) || (newFilterId === 5)) //If there's vde system
          {
            if (!this.get("enabled"))
              this.set("enabled", true);
          } else {
            if (this.get("enabled"))
              this.set("enabled", false);
          }

          this.trigger("render:requested");
          this.trigger("updateViews");
        },

        isPossibleToUpdateExpansion1: function(newExpansionValue) {
          var valueToSubtract = 8;

          if (this.get("accessories").expansion2.value === true) {
            valueToSubtract += 8;
          }

          if (newExpansionValue !== true) {
            if ((BticinoS4B.Instances.Models.ApplicationModel.get("maxDerivates") - valueToSubtract) >= this.get("accessories").vctQuantity) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },

        isPossibleToUpdateExpansion2: function(newExpansionValue) {
          var valueToSubtract = 8;

          if (newExpansionValue !== true) {
            if ((BticinoS4B.Instances.Models.ApplicationModel.get("maxDerivates") - valueToSubtract) >= this.get("accessories").vctQuantity) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
      })
    });

    // Required, return the module for AMD compliance
    return telephony;

  });